import http from "@/plugins/http";
//注意GET 和POST时，参数不同，一个时params 一个时data
export function codeList(data) {
    return http({
        url: `/code/list`,
        params: data,
        method: "GET"
    });
}

export function addCode(data) {
    return http({
        url: `/code/add`,
        data:data,
        method: 'POST',
    })
}

export function updateCode(data) {
    return http({
        url: `/code/update`,
        data:data,
        method: 'POST',
    })
}

export function deleteCode(data) {
    return http({
        url: `/code/delete`,
        params: data,
        method: "GET"
    })
}

export function codeInfo(data) {
    return http({
        url: `/code/info`,
        params: data,
        method: "GET"
    })
}
